<template>
    <div id="app">

        <SelectVisitorDialog v-model="isChangeBelongVisible" :curBelongIdIn="contentObj.vid" @confirm="belongConfirm"></SelectVisitorDialog>
        
        <div v-if="isSmallScreen">
            <CommonHeader></CommonHeader>
        </div>
        <div v-else>
            <header class=" fixed sticky top-0 left-0 right-0 h-[60px] bg-gray-700 text-white flex items-center justify-between p-4">
                <div class="flex items-center">
                    <img src="@/assets/logo.png" alt="Logo" class="h-8 mr-2" />
                    <!--<span class="text-xl">识心智能</span>-->
                </div>
                <LoginModule @loginSucc="handleLogin" ref="loginModule" />
            </header>
        </div>
        <main class="flex w-full h-[calc(100vh-60px)]">
            <div class="container mx-auto bg-white rounded-lg shadow-md overflow-hidden">

                <!-- 手机端布局 -->
                <div v-if="isSmallScreen" class="flex flex-col">
                    <div class="p-4">
                        <div class="flex items-center mb-4">
                            <div class="flex flex-row items-center">
                                <span class="text-2xl p-3 text-blue-700 bg-blue-200 rounded-full ">  {{contentObj.visitorName?contentObj.visitorName.charAt(0):"无"}}</span>
                                <span class=" text-xl font-semibold text-gray-700 text-left">{{contentObj.visitorName?contentObj.visitorName :  contentObj.commiName ? contentObj.commiName :"暂无"}}</span>
                            </div>
                            <div>

                                <div class="flex flex-col gap-2 text-sm text-left">
                                    <p>
                                        <span class="text-gray-400 mr-1">联系方式</span>
                                        <span v-if="contentObj.phone && contentObj.phone.length" class="text-gray-700">{{contentObj.phone}}</span>
                                        <span v-else class="text-gray-700">用户选择匿名填写，无需提供手机号</span>
                                    </p>
                                    <p>
                                        <span class="text-gray-400  mr-1">问卷生成时间</span>
                                        <span class="text-gray-700">{{contentObj.createTime}}</span>
                                    </p>
                                    <p>
                                        <span class="text-gray-400  mr-1">问卷填写时间</span>
                                        <span class="text-gray-700">{{contentObj.answerTime}}</span>
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div v-if="contentObj.resFile" class="mb-4">
                            <div v-if="curScaleObj" class="bg-blue-100 rounded-2xl p-3 mb-4" style="background: linear-gradient(to top, rgb(107, 165, 255), rgb(69, 72, 247)); ">
                                <div class="px-1 text-lg font-bold text-white">{{ curScaleObj["Name"] ? curScaleObj["Name"] : "未知"}}</div>
                                <div class="text-center rounded-xl bg-white p-3 mt-1">
                                    <!--<span class="text-custom-blue text-sm">{{curScaleObj["core_value"]}}</span>-->
                                    <p class="text-gray-600 text-sm"> {{curScaleObj["Introduction"]}}</p>
                                </div>
                            </div>

                            <div class="border shadow-lg border-gray-300 bg-white rounded-lg">
                                <div class="font-extrabold text-gray-700 p-3 text-left">
                                    心理评估
                                    <img src="https://6d65-mentor-3gyob3y3bdbc2bdb-1305613707.tcb.qcloud.la/static/subtitle_line_lg.svg" class="w-16" />
                                </div>
                                <div class="text-left">
                                    <p class="text-gray-500 p-3 text-sm" v-html="contentObj.resFile"></p>
                                </div>
                                <div class="flex flex-col items-center mt-4 p-3">
                                    <div class="text-gray-400 text-xs">
                                        AI生成内容仅供参考
                                    </div>
                                    <div class="text-gray-400 text-xs">
                                        识心智能对所有内容拥有最终解释权
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-else class="bg-gray-50 p-6 rounded-lg">
                            <div class="text-xl font-semibold text-gray-700 ">{{curScaleObj?.Name || "加载中..."}}</div>
                            <div class="mt-12 items-center text-center">做题结果分析中...</div>
                        </div>

                        <div class="mt-4 p-3 border rounded-xl shadow-md bg-white">
                            <h3 class="text-lg font-semibold text-gray-800 mb-3 px-1">答题详情</h3>
                            <div class="space-y-3">
                                <div v-for="(item, index) in QALlist" :key="index" class="bg-gray-50 rounded-lg p-3 hover:bg-gray-100 transition-colors duration-200">
                                    <div class="flex items-start space-x-2">
                                        <!-- 序号圆形 -->
                                        <div class="flex-shrink-0 w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center text-blue-700 font-bold text-sm">
                                            {{ index + 1 }}
                                        </div>

                                        <!-- 问答内容 -->
                                        <div class="flex-1 min-w-0">
                                            <!-- 问题部分 -->
                                            <div class="mb-2 p-2 bg-white rounded-md shadow-sm">
                                                <div class="flex items-start">
                                                    <span class="flex-shrink-0 w-5 h-5 rounded-full bg-yellow-100 flex items-center justify-center text-xs text-yellow-800 mt-0.5 mr-1">问</span>
                                                    <p class="text-gray-800 text-sm break-words">{{ item.q }}</p>
                                                </div>
                                            </div>

                                            <!-- 答案部分 -->
                                            <div class="p-2 bg-blue-50 rounded-md shadow-sm">
                                                <div class="flex items-start">
                                                    <span class="flex-shrink-0 w-5 h-5 rounded-full bg-blue-200 flex items-center justify-center text-xs text-blue-800 mt-0.5 mr-1">答</span>
                                                    <p class="text-gray-700 text-sm break-words">{{ item.a }}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- PC端布局 -->
                <div v-else class="flex justify-center gap-12">
                    <div class="flex-1 p-4">
                        <div class="flex items-center mb-4 flex-row">
                            <!--<div class="mr-5 bg-blue-200 rounded-full w-16 h-16 flex  items-center justify-center text-blue-700">
                            <span class="text-3xl">  {{contentObj.visitorName?contentObj.visitorName.charAt(0):"无"}}</span>
                        </div>
                        <h2 class="mb-3 text-2xl font-semibold text-gray-700 text-left">{{contentObj.visitorName?contentObj.visitorName :  contentObj.commiName ? contentObj.commiName :"暂无"}}</h2>-->

                        <div class="flex  flex-row items-center justify-between">
                            <div class="flex  flex-row items-center">
                                <div class="bg-purple-50 p-1.5 rounded-full mr-2">
                                    <i class="fas fa-user text-purple-500 text-xs"></i>
                                </div>
                                <span class="text-gray-500">来访归属</span>
                            </div>
                            <div class="flex flex-row items-center ">
                                <button @click="belongHandle"
                                        class="flex flex-row items-center mt-1 px-2 py-1 rounded-full bg-gray-100 text-xs max-w-full active:bg-gray-200 transition-colors">
                                    <span class="rounded-full p-0.5 px-1.5 text-white" :style="{ backgroundColor: btnColor }">
                                        {{ contentObj && contentObj.visitorName ? contentObj.visitorName.charAt(0) : '无' }}
                                    </span>
                                    <span class="mx-1 truncate">{{contentObj && contentObj.visitorName ? contentObj.visitorName:"无归属"}}</span>
                                    <i class="fas fa-pencil-alt ml-auto text-xs"></i>
                                </button>
                            </div>
                        </div>
                        </div>
                        <div class="flex flex-row">
                            <div class="flex  gap-6 items-left flex-col">
                                <p class="text-sm flex flex-row">
                                    <span class="text-gray-400 mr-1">联系方式</span>
                                    <span v-if="contentObj.phone && contentObj.phone.length" class="text-gray-700">{{contentObj.phone}}</span>
                                    <span v-else class="text-gray-700">用户选择匿名填写，无需提供手机号</span>
                                </p>
                                <p class="text-sm flex flex-row">
                                    <span class="text-gray-400  mr-1">问卷生成时间</span>
                                    <span class="text-gray-700">{{contentObj.createTime}}</span>
                                </p>
                                <p class="text-sm flex flex-row">
                                    <span class="text-gray-400  mr-1">问卷填写时间</span>
                                    <span class="text-gray-700">{{contentObj.answerTime}}</span>
                                </p>
                            </div>
                        </div>

                        <div class="flex gap-6 mt-3">
                            <div v-if="contentObj.resFile" class="flex-1 flex flex-col rounded border overflow-y-auto scrollable bg-gradient-to-b from-blue-100">
                                <div>
                                    <div v-if="curScaleObj" class="bg-blue-100 rounded-3xl p-3" style="background: linear-gradient(to top, rgb(107, 165, 255), rgb(69, 72, 247)); ">
                                        <div class="px-1 text-xl font-bold text-white">{{ curScaleObj["Name"] ? curScaleObj["Name"] : "未知"}}</div>
                                        <div class="text-center rounded-xl bg-white p-4 mt-1">
                                            <span class="text-gray-600">{{curScaleObj["core_value"]}}</span>
                                            <p class="text-gray-600"> {{curScaleObj["Introduction"]}}</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="h-full mt-8">
                                    <div class="p-4 border shadow-lg border-gray-300 bg-white rounded-lg">
                                        <div class="flex flex-col items-center mt-4">
                                            <div class="text-gray-400 text-sm">
                                                AI生成内容仅供参考
                                            </div>
                                            <div class="text-gray-400 text-sm">
                                                识心智能对所有内容拥有最终解释权
                                            </div>
                                        </div>
                                        <div class="font-extrabold text-gray-700 p-2 text-left">
                                            心理评估
                                            <img src="https://6d65-mentor-3gyob3y3bdbc2bdb-1305613707.tcb.qcloud.la/static/subtitle_line_lg.svg" />
                                        </div>
                                        <div class="text-left">
                                            <p class="text-gray-500 p-2" v-html="contentObj.resFile"></p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-else class="flex-1 bg-gray-50 p-4 rounded-lg">
                                <div class="text-2xl font-semibold text-gray-700 ">{{curScaleObj?.Name || "加载中..."}}</div>
                                <div class="mt-24 items-center text-center">做题结果分析中...</div>
                            </div>
                        </div>
                    </div>

                    <div class="flex-1 p-8 border border-rounded-2xl rounded-2xl shadow-lg overflow-y-auto scrollable mr-9">
                        <h3 class="text-2xl font-semibold text-gray-700">答题详情</h3>
                        <div class="">
                            <div v-for="(item, index) in QALlist" :key="index" class="flex flex-col mt-3 text-sm">
                                <div class="bg-gray-50">
                                    <div class="font-medium text-blue-600 font-extrabold text-xl text-left">{{ index + 1 }}</div>
                                    <div class="font-medium px-6 p-1 flex items-center gap-4 -mt-2">
                                        <span class="bg-gray-200 text-yellow-800 rounded-full w-8 h-8 flex items-center justify-center"> 问</span>
                                        {{ item.q }}
                                    </div>
                                    <div class="text-gray-700 px-6 flex items-center gap-4">
                                        <span class="bg-blue-100 text-gray-500 rounded-full w-8 h-8 flex items-center justify-center"> 答</span>
                                        {{ item.a }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
    import LoginModule from './LoginModule.vue';
    import hljs from 'highlight.js'
    import MarkdownIt from 'markdown-it'
    import axios from 'axios';
    import { mapState, mapActions } from 'vuex'
    import SelectVisitorDialog from './subassembly/SelectVisitorDialog'; 
    import CommonHeader from './subassembly/CommonHeader.vue';
export default {
        name: "questionResult",
        components: {
            LoginModule,
            CommonHeader,
            SelectVisitorDialog
        },
        data() {
            return {
                isChangeBelongVisible: false,
                markdownIt: {},
                isRecordVisible: false,
                curScaleObj:null,
                contentObj: {
                    
                },
                btnColor:'rgb(25, 75, 255)',
                QALlist: [
                    /*{
                        q: "即使在不熟悉的社交场合里我仍然感到放松。",
                        a: "A.是"
                    },*/
                ]
            };
        },
        computed: {
            ...mapState({
                globalScales: state => state.globalScales,
            }),
        },
        methods: {
            ...mapActions(["fetchGlobalScales"]),
            belongHandle() {
                this.isChangeBelongVisible = true;
            },
            async fetchScales() {
                await this.fetchGlobalScales();
            },
            
            async belongConfirm(choiceObj) {
                console.log("choiceObj", choiceObj);
                const token = localStorage.getItem('token');
                if (!token) {
                    return;
                }
                const url = '/api/questionnaire/belong';
                const data = {
                    taskid: this.contentObj.id,
                    newVid: choiceObj.id,
                };
                const headers = {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json'
                };

                try {
                    const response = await axios.post(url, data, { headers });
                    if (response.status === 200 && response.data.code=="00") {
                        console.log(response.data);
                        this.$message.success("归属修改成功");
                        
                        this.contentObj.vid = choiceObj.id;
                        this.contentObj.visitorName = choiceObj.vname;
                    } else {
                        console.error('请求失败，状态码:', response.status);
                    }
                } catch (error) {
                    console.error('get error:', error.message);
                }
            },
            handleLogin() { },
            formatTimestamp(timestamp) {
                const date = new Date(timestamp);
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始
                const day = String(date.getDate()).padStart(2, '0');
                const hours = String(date.getHours()).padStart(2, '0');
                const minutes = String(date.getMinutes()).padStart(2, '0');
                const seconds = String(date.getSeconds()).padStart(2, '0');
                return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
            },

            parseTestResponse(response) {
                this.contentObj = response.info;
                if (this.contentObj.loginInfo) {
                    var loginInfo = JSON.parse(this.contentObj.loginInfo);
                    this.contentObj["phone"] = loginInfo.phoneNumber;
                    this.contentObj["commiName"] = loginInfo.name;
                    console.log("loginInfo");
                    console.log(loginInfo);
                }
                console.log("contentObj", this.contentObj);
                this.curScaleObj = this.globalScales.find(scale => scale._id === this.contentObj.questionId);
                console.log("curScaleObj",this.curScaleObj);
                //结果
                if (this.contentObj.resFile) {
                    this.contentObj.resFile = this.markdownIt.render(this.contentObj.resFile);
                }
                
                const answerInfo = response.info.answerInfo;
                console.log("answerInfo");
                console.log(answerInfo);

                //var total = 0;
                
                if (answerInfo && this.curScaleObj) {
                    // && this.curScaleObj.Total_items
                    const ans = answerInfo.split("%");
                    //const length = Math.min(parseInt(this.curScaleObj.Total_items), ans.length);
                    const length = ans.length;
                    console.log("2ans",ans);
                    for (let i = 0; i < length; i++) {
                        this.QALlist.push({
                            q: this.curScaleObj.content[i].query,
                            a: ans[i]
                        });
                    }
                }
                console.log("this.QALlist");
                console.log(this.QALlist);
            },
            async initParse() {
                const token = localStorage.getItem('token');
                if (!token) {
                    return;
                }
                var params = localStorage.getItem("router");
                if (!params) {
                    return;
                }
                try {
                    await this.fetchScales();
                } catch (error) {
                    console.log("get scales error");
                    console.log(error);
                    this.$message.error("获取数据失败，请稍后重试！");
                    return;
                }
                var paramsObj = JSON.parse(atob(params));
                console.log("uri:" + paramsObj.id);
                const url = `/api/questionnaire/get-info/${paramsObj.id}`;
                const headers = {
                    Authorization: `Bearer ${token}`,
                };
                try {
                    const response = await axios.get(url, { headers });
                    if (response.status === 200) {
                        console.log("uri:========");
                        console.log(response.data);
                        if (response.data.code != "00") {
                            console.log("get check uri error" + response.data.code);
                            return;
                        }
                        
                        this.parseTestResponse(response.data);
                    } else {
                        console.error('请求失败，状态码:', response.status);
                    }
                } catch (error) {
                    console.error('get error:', error.message);
                }
            },
        },
        created() {
            this.initParse();
        },
        mounted() {
            this.markdownIt = MarkdownIt({
                html: true,
                linkify: true,
                highlight: function (str, lang) {
                    if (lang && hljs.getLanguage(lang)) {
                        try {
                            return hljs.highlight(str, { language: lang }).value
                        } catch (__) {
                            console.log("1");
                        }
                    }
                    return '' // use external default escaping
                }
            })
        }
};
</script>

<style >
    @import url('https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css');

    /* 纯移动端适配 - 使用max-width: 767px隔离 */
    @media (max-width: 767px) {
        #app {
            padding: 0;
        }

        header {
            padding: 0.5rem;
        }

        main {
            padding-top: 60px;
            height: auto;
            min-height: calc(100vh - 60px);
        }

        .container {
            padding: 0.5rem;
        }

        /* 用户信息区域优化 */
        .user-info-container {
            padding: 0.5rem;
            margin-bottom: 0.5rem;
        }

        .user-avatar {
            width: 2.5rem;
            height: 2.5rem;
            font-size: 1rem;
        }

        .user-name {
            font-size: 1rem;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .user-meta {
            font-size: 0.75rem;
            flex-direction: column;
            gap: 0.25rem;
        }

        /* 内容区域改为垂直堆叠 */
        .content-container {
            flex-direction: column;
            gap: 1rem;
        }

        /* 分析结果区域 */
        .analysis-section {
            width: 100%;
            padding: 0.5rem;
            margin-left: 0;
            max-height: 50vh;
        }

        /* 答题详情区域 */
        .detail-section {
            width: 100%;
            padding: 0.5rem;
            margin-right: 0;
            max-height: 50vh;
        }

        /* 题目卡片调整 */
        .question-card {
            padding: 0.25rem;
        }

        .question-index {
            font-size: 0.875rem;
        }

        .q-mark, .a-mark {
            width: 1.5rem;
            height: 1.5rem;
            font-size: 0.75rem;
        }
    }
</style>